import Entity from '../entity'

export default class ClaimAttachment extends Entity<number>{
    claim_id: number;
    name: string;
    filename: string;
    comment: string;

    fileData: string;
    filetype: string;
}


